export const leaveHistory = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "username",
    name: "Name",
  },
  {
    key: "department_name",
    name: "Department",
  },
  {
    key: "option",
    name: "Leave Type",
  },
  {
    key: "from_date",
    name: "From",
  },
  {
    key: "to_date",
    name: "To",
  },
  {
    key: "business_days",
    name: "Duration",
  },
  {
    key: "approver_name",
    name: "Approver",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const permissionHistory = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "username",
    name: "Name",
  },
  {
    key: "department_name",
    name: "Department",
  },

  {
    key: "from_date",
    name: "Date",
  },
  {
    key: "total_time",
    name: "Duration",
  },
  {
    key: "approver_name",
    name: "Approver",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const teamZoneLoanHistory = [
  { name: "Employee Name", key: "user_name" },
  { name: "Date", key: "applied_date" },
  { name: "Department", key: "department_name" },
  { name: "Loan Amount", key: "principal_amount" },
  { name: "Tenure", key: "tenure_months" },
  { name: "Interest", key: "interest_rate" },
  { name: "Total Amount", key: "monthly_installment" },
  { name: "Loan Type", key: "loan_type" },
  { name: "Interest Type", key: "interest_type" },
  { name: "Status", key: "status" },
  { name: "Action" },
];

export const overTimeHistoryHeader = [
  {
    key: "date",
    name: "Date",
  },
  {
    key: "username",
    name: "Employee name",
  },
  {
    key: "shift",
    name: "Shift Name",
  },
  {
    key: "work_hours",
    name: "Working Hours",
  },
  {
    key: "shift_time",
    name: "Shift Time",
  },
  {
    key: "overtime_start_formated",
    name: "OverTime Start",
  },
  {
    key: "overtime_end_formated",
    name: "OverTime End",
  },
  {
    key: "over_time",
    name: "Over Time",
  },
  {
    key: "approvedby",
    name: "Approver",
  },
  {
    key: "createdat",
    name: "Approved At",
  },
];

export const overTimeRejectHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "username",
    name: "Employee name",
  },
  {
    key: "shift",
    name: "Shift Name",
  },
  {
    key: "work_hours",
    name: "Working Hours",
  },
  {
    key: "shift_time",
    name: "Shift Time",
  },
  {
    key: "overtime_start_formated",
    name: "OverTime Start",
  },
  {
    key: "overtime_end_formated",
    name: "OverTime End",
  },
  {
    key: "over_time",
    name: "Over Time",
  },
  {
    key: "approvedby",
    name: "Rejected by",
  },
  {
    key: "createdat",
    name: "Rejected At",
  },
];

export const weekoffRejectHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "date",
    name: "Date",
  },

  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    name: "Approval Type",
    key: "approval_type",
  },
  {
    key: "check_in_datetime",
    name: "Check In",
  },
  {
    key: "check_out_datetime",
    name: "Check Out",
  },
  {
    key: "rejectedby",
    name: "Rejected by",
  },
  {
    key: "rejectedat",
    name: "Rejected At",
  },
];

export const incentivePendingHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "incentive_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "calculation_mode",
    name: "Calculation Mode",
  },
  {
    key: "fixed_amount",
    name: "Amount",
  },
  {
    key: "eligibility_met_employees",
    name: "Eligibility Met Person",
  },
  {
    key: "Action",
    name: "Action",
  },
];

export const incentiveHistoryHeader = [
  {
    key: "incentive_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "calculation_mode",
    name: "Calculation Mode",
  },
  {
    key: "fixed_amount",
    name: "Amount",
  },
  {
    key: "eligibility_met_employees",
    name: "Eligibility Met Person",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const EligibilityType = [
  {
    id: 1,
    name: "Department",
  },
  {
    id: 2,
    name: "Designation",
  },
  {
    id: 3,
    name: "Role",
  },
  {
    id: 4,
    name: "Individual",
  },
  {
    id: 4,
    name: "Payrollgroup",
  },
];

export const EligibleEmployeeHeader = [
  {
    key: "employee_id",
    name: "Employee ID",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "department",
    name: "Department",
  },
  {
    key: "designation",
    name: "Designation",
  },
  {
    key: "role",
    name: "Role",
  },
];

export const EligibleMetEmployeeHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_id",
    name: "Emp ID",
  },
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "department",
    name: "Department",
  },
  {
    key: "designation",
    name: "Designation",
  },
  {
    key: "role",
    name: "Role",
  },
];

export const EligibleMetEmployeeCustomHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "incentive_amount",
    name: "Amount",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const RemovedEmployeeHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "incentive_amount",
    name: "Amount",
  },
];
